import { useMemo } from "react"

import { api } from "~/utils/api"

const usePrimaryWarehouses = () => {
  const { data: warehouses } = api.warehouse.get.useQuery()
  return useMemo(() => warehouses?.filter((warehouse) => warehouse.isPrimary) || [], [warehouses])
}

export { usePrimaryWarehouses }
